export const integerRange = (min, max) => {
    return Math.floor(floatRange(min, max));
};

export const floatRange = (min, max) => {
    const n = min + Math.random() * (max - min);

    return n;
};

export const value = () => {
    return Math.random();
};
